import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { store } from "./store.js";
import { router } from "./router.js";
import 'moment/locale/pt-br';
import { unregister } from './registerServiceWorker';
import 'react-table/react-table.css';
//import ErrorBoundary from "./ErrorBoundary";

ReactDOM.render( 
  <Provider store={store}>
    {/*<ErrorBoundary>*/}
    {router}
    {/*</ErrorBoundary>*/}
  </Provider>,
  document.getElementById('app')
);
unregister();
